module.exports = __webpack_public_path__ + "img/nucleus-rgb.1f481247.png";